module.exports = __webpack_public_path__ + "img/lucky-draw-container.a146f11.png";